<template>
<div class="layout">
  <div class="layout-header">
    <el-button type="primary" size="mini" @click="send">发送</el-button>
    <el-button type="danger" size="mini" @click="removeItems">移除</el-button>
  </div>
  <div class="layout-content">
    <div class="content-left">

      <div class="layout-msg">
        <el-descriptions :column="1" border size="mini" :label-style="{width: '120px'}">
          <el-descriptions-item label="模版选择">
            <span style="margin-right: 10px" v-if="selectTemplate.name">{{ selectTemplate.name }}</span>
            <el-button type="primary" size="mini" @click="openSelectTemplateDialog">{{ !selectTemplate.name ? '选择模版' : '重新选择' }}</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="消息">
            <el-input type="textarea" :rows="4" size="mini" placeholder="请输入内容" v-model="fromData.text"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="图片">
            <el-button type="primary" size="mini" @click="uploadFile">上传图片</el-button>
            <div v-if="fromData.images.length>0" class="image-list">
              <div v-for="(image, index) in fromData.images" :key="image" class="image-item">
                <el-image :src="image" fit="cover" style="max-width: 50px; max-height: 50px;" :preview-src-list="fromData.images"></el-image>
                <i class="el-icon-close image-remove" @click="removeImage(index)"></i>
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="layout-list">
        <div class="table-wrap1">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%" height="40vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45" fixed></el-table-column>
            <el-table-column
              prop="房产信息"
              label="房产信息" width="320" fixed></el-table-column>
            <el-table-column
              prop="区域"
              label="区域"
              width="90">
            </el-table-column>
            <el-table-column
              prop="业主"
              label="业主姓名"
              width="100">
            </el-table-column>
            <el-table-column
              prop="业主电话"
              label="业主电话"
              width="150">
            </el-table-column>
            <el-table-column
              prop="房态"
              label="房态"
              width="100">
            </el-table-column>
            <el-table-column
              prop="欠费起始月份"
              label="欠费起始月份"
              width="120">
            </el-table-column>
            <el-table-column
              prop="欠费月数"
              label="欠费月数"
              width="100">
            </el-table-column>
            <el-table-column
              prop="欠费金额/诉讼金额"
              label="欠费金额/诉讼金额"
              width="140">
              <template slot-scope="scope">
                <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini">{{ formatMoney(scope.row['欠费金额'],2) }}</el-link>
                <span v-if="scope.row['催缴类型']==='诉讼'">{{formatMoney(scope.row['诉讼金额'],2)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="计划催缴月份"
              label="计划催缴月份"
              width="100">
            </el-table-column>
            <el-table-column
              prop="催缴类型"
              label="催缴类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="账龄类型"
              label="账龄类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="第三方合作单位"
              label="第三方合作单位"
              width="150">
            </el-table-column>
            <el-table-column
              prop="缴费类型"
              label="缴费类型"
              width="90">
            </el-table-column>
            <el-table-column
              prop="上次缴费时间"
              label="上次缴费时间"
              width="170"></el-table-column>
            <el-table-column
              prop="one_gj_time"
              label="第一次催费跟进时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="two_gj_time"
              label="第二次催费跟进时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="three_gj_time"
              label="第三次催费跟进时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="cur_month_times"
              label="月催费次数"
              width="90">
            </el-table-column>
            <el-table-column
              prop="cur_year_times"
              label="年催费次数"
              width="90">
            </el-table-column>
            <el-table-column
              prop="欠费类型"
              label="欠费类型"
              width="150">
              <template slot-scope="scope">
                <span v-if="scope.row['欠费类型']">{{scope.row['欠费类型']}}</span>
                <span v-if="scope.row['欠费类型原因']"> ： {{scope.row['欠费类型原因']}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="业主诉求"
              label="业主诉求"
              width="150">
            </el-table-column>
            <el-table-column
              prop="解决措施"
              label="催费措施"
              width="150">
            </el-table-column>
            <el-table-column
              prop="备注"
              label="备注"
              width="200">
            </el-table-column>
            <el-table-column
              label="操作"
              width="70" fixed="right">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  size="mini"
                  @click="removeItem(scope.row)"
                >移除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap1">
          <div class="pagination-info">
            合计 {{ pageData.total }} 户
          </div>
          <el-pagination
            background layout="sizes,total,prev, pager, next"
            :total="pageData.total"
            :page-size="pageData.pageSize"
            :current-page="pageData.page"
            @current-change="pageChange"
            @size-change="handleSizeChange"
            :page-sizes="[15,20,50,100, 200, 300, 400,500,1000]"
          ></el-pagination>
        </div>
      </div>

    </div>
    <div class="content-right">
      <div class="review-msg-title">消息预览</div>
      <div class="review-msg">
        <div class="review-msg-content">
          <pre>{{fromData.text}}<br>缴费地址：<a :href="fromData.url" target="_blank">{{fromData.url}}</a></pre>
        </div>
        <div v-if="fromData.images.length>0">
          <el-image v-for="image in fromData.images" :key="image" :src="image" fit="cover" style="max-width: 200px; max-height: 200px;" :preview-src-list="fromData.images"></el-image>
        </div>
      </div>
    </div>
  </div>

<SelectTemplateView ref="selectTemplateRef" @selectCurTemplate="selectCurTemplate"/>
</div>
</template>

<script>
import Http from "../../common/Http";
import ButlerHttp from "../../common/ButlerHttp";
import SelectTemplateView from "../../projectCollectionTemplate/template/select.vue"

export default {
  name: "LegalHouseMsg",
  components: { SelectTemplateView },
  props: {
    project_id: {
      type: Number,
      default: 0
    },
    list:{
      type: Array,
      default: () => []
    },
    urge_type:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      data_ch_md5s: [],
      multipleSelection: [],
      pageData: {
        list: [],
        total: 0,
        page: 1,
        pageSize: 15,
      },
      fromData:{
        text: '',
        images: [],
        url:""
      },
      selectTemplateRef: null,
      selectTemplate: {}
    }
  },
  created() {
    const that = this
    that.dataList = ERP.getLocalStore(`legal_house_list_${that.project_id}_${that.urge_type}`) || []
    that.data_ch_md5s = that.dataList.map(item => item.ch_md5)
    that.list.forEach(item => {
      if(!that.data_ch_md5s.includes(item.ch_md5)) {
        that.dataList.push(item)
      }
    })
    ERP.setLocalStore(`legal_house_list_${that.project_id}_${that.urge_type}`, that.dataList)
    that.getData();
    that.getProjectUrl();
  },
  methods: {
    async getData() {
      const that=this;
      that.pageData.total=that.dataList.length;
      that.pageData.list=that.dataList.slice((that.pageData.page-1)*that.pageData.pageSize,that.pageData.page*that.pageData.pageSize);
    },
    pageChange(page) {
      this.pageData.page = page
      this.getData()
    },
    handleSizeChange(pageSize) {
      this.pageData.pageSize = pageSize
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    removeItem(row) {
      const that = this
      that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.dataList.splice(that.dataList.indexOf(row),1)
        ERP.setLocalStore(`legal_house_list_${that.project_id}_${that.urge_type}`, that.dataList)
        that.getData()
        that.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    removeItems() {
      const that = this
      that.$confirm(that.multipleSelection.length>0?'此操作将删除所选数据, 是否继续?':'此操作将删除所有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if(that.multipleSelection.length>0){
          that.dataList = that.dataList.filter(item => !that.multipleSelection.includes(item))
        }else {
          that.dataList.splice(0,that.dataList.length)
        }


        ERP.setLocalStore(`legal_house_list_${that.project_id}_${that.urge_type}`, that.dataList)
        that.getData()
        that.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    uploadFile() {
      const that = this
      Http.uploadFile(file=>{
        that.fromData.images.push(file)
        that.$message({
          type: 'success',
          message: '上传成功!'
        })
      },true)

    },
    removeImage(index) {
      this.fromData.images.splice(index, 1)
    },
    send(){
      const that = this
      let houseIds=[];
      let houseList=[]
      if(that.multipleSelection.length>0){
        houseIds = that.dataList.filter(item => that.multipleSelection.includes(item)).map(item => item['房产ID'])
        houseList = that.dataList.filter(item => that.multipleSelection.includes(item)).map(item => {
          return {
            house_id: item['房产ID'],
            customer_id: item.customer_id||0,
            customer_name: item['业主']||'',
            phone: item['业主电话']||'',
            money: item['欠费金额']||'',
            type_age:item['账龄类型']||'',
            ch_md5: item.ch_md5,
          }
        })
      }else {
        houseIds = that.dataList.map(item => item['房产ID'])
        houseList = that.dataList.map(item => {
          return {
            house_id: item['房产ID'],
            customer_id: item.customer_id||0,
            customer_name: item['业主']||'',
            phone: item['业主电话']||'',
            money: item['欠费金额']||'',
            type_age:item['账龄类型']||'',
            ch_md5: item.ch_md5,
          }
        })
      }
      Http.post("https://quality.gdzawy.com/weworkSender/GroupSend/send",{
        text: that.fromData.text+"\n缴费地址："+that.fromData.url,
        image: that.fromData.images.join(","),
        house_ids: houseIds.join(","),
        project_id: that.project_id,
        house_list: JSON.stringify(houseList)
      },(res) => {
        if(res.code===0){
          if(that.multipleSelection.length>0){
            that.dataList=that.dataList.filter(item => !that.multipleSelection.includes(item))
          }else {
            that.dataList=[]
          }
          ERP.setLocalStore(`legal_house_list_${that.project_id}_${that.urge_type}`, that.dataList)
          that.getData();
          that.$message({
            type: 'success',
            message: '发送成功!'
          })
        }else {
          that.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    getProjectUrl(){
      const that=this;
      ButlerHttp.post("project/getProjectUrl",{project_id: that.project_id},(res) => {
        if(res.code){
          that.fromData.url = res.data
        }else {
          that.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    openSelectTemplateDialog() {
      this.$refs.selectTemplateRef.show()
    },
    selectCurTemplate(data) {
      this.selectTemplate = data
      this.fromData.text = data.content
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";

.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  background: #f5f7fa;

  .layout-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    padding: 10px 16px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }

  .layout-content {
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: 8px;
    min-height: 0;

    .content-left {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .layout-msg {
        background: #fff;
        border-radius: 6px;
        padding: 8px 16px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        ::v-deep .el-descriptions {
          .el-descriptions-item__label {
            background: #fafafa;
            font-weight: 500;
          }
        }

        .image-list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 8px;
        }

        .image-item {
          position: relative;
          display: inline-block;

          .el-image {
            border-radius: 4px;
            border: 1px solid #ebeef5;
          }

          .image-remove {
            position: absolute;
            top: -6px;
            right: -6px;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            font-size: 8px;
            color: #fff;
            background: #f56c6c;
            border-radius: 50%;
            cursor: pointer;
            transition: background 0.2s;

            &:hover {
              background: #e04040;
            }
          }
        }
      }

      .layout-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 6px;
        padding: 8px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
        min-height: 0;

        .table-wrap1 {
          flex: 1;
          min-height: 0;

          ::v-deep .el-table {
            border-radius: 4px;
          }
        }

        .pagination-wrap1 {
          margin-top: 8px;
          padding-top: 10px;
          border-top: 1px solid #ebeef5;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .pagination-info {
            margin-left: 8px;
            font-size: 16px;
            color: #fd002b;
          }
        }
      }
    }

    .content-right {
      width: 400px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 6px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
      overflow: hidden;

      .review-msg-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        padding: 8px 16px;
        border-bottom: 1px solid #ebeef5;
        background: #fafafa;
        flex-shrink: 0;
      }

      .review-msg {
        flex: 1;
        padding: 16px;
        overflow-y: auto;

        .review-msg-content {
          margin-bottom: 8px;
          white-space: pre-wrap;
          word-break: break-word;
          font-size: 13px;
          line-height: 1.6;
          color: #606266;
          background: #f4f4f5;
          border-radius: 8px;
          padding: 10px 8px;

          pre {
            margin: 0;
            font-family: inherit;
            white-space: pre-wrap;
          }
        }

        .el-image {
          margin: 0 6px 6px 0;
          border-radius: 6px;
          border: 1px solid #ebeef5;
        }
      }
    }
  }

  .layout-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;
    padding: 10px 16px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/msg/LegalHouseMsg.vue